const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/language-manager");
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();
const LoginManager = require("Sources/services/login-manager");
const StorageController = require("Sources/controllers/storage-controller");
const FormValidator = require("Sources/components/form-validator");
const Constants = require("Sources/config/constants")

import UserServices from "../services/user-services";

require("Styles/pages/login.scss");

$(function()
{
  Shared.init();
  LoginPage.init();
});

let LoginPage = {};

((LoginPage) =>
{
  let loginFormValidator = null;

  const LOGIN_BTN_ID = "#login-btn";
  const USERNAME_INPUT_ID = "#login-username-input";
  const PASSWORD_INPUT_ID = "#login-password-input";
  const LINK_BOARDCODE_INPUT = "#link-boardcode-input";
  const LINK_BOARDCODE_BTN = "#link-boardcode-btn";
  const LINK_BOARDCODE_BACK_BTN = "#link-boardcode-back-btn";

  LoginPage.init = function()
  {
    setUpLoginForm();
    setUpEventListeners();

    clearAllFieldErrors();

    showLoginPart();
  };

  function setUpEventListeners()
  {
    $(LOGIN_BTN_ID).on("click", function(e)
    {
      let $this = $(this);

      let isValid = loginFormValidator.validate();

      if(isValid)
      {
        $this.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");

        login().finally(() =>
        {
          $this.prop("disabled", false).removeClass("btn-loading");
        });
      }
    });

    $(USERNAME_INPUT_ID).on("input", function(e)
    {
      $(this).removeClass("input-error");
    });

    $(PASSWORD_INPUT_ID).on("input", function(e)
    {
      $(this).removeClass("input-error");
    });

    $(PASSWORD_INPUT_ID).on("keyup", function(e)
    {
      if(e.keyCode === 13)
      {
        $(this).blur();
        login();
      }
    });

    // only enable login button if a username and password is filled in
    $("#login-username-input, #login-password-input").on("keyup", function()
    {
      $("#login-username-input-error").text("");

      let usernameInput = $("#login-username-input");
      let passwordInput = $("#login-password-input");

      if (utils.isNullOrEmpty(usernameInput.val()) || utils.isNullOrEmpty(passwordInput.val()))
      {
        $(LOGIN_BTN_ID).prop("disabled", true);
      }
      else
      {
        $(LOGIN_BTN_ID).prop("disabled", false);
      }
    });

    // link boardcode

    $(LINK_BOARDCODE_INPUT).on("input", function(e)
    {
      $(LINK_BOARDCODE_INPUT).removeClass("is-invalid");
    });

    $(LINK_BOARDCODE_BTN).on("click", function(e)
    {
      linkBoardcode();
    });

    $(LINK_BOARDCODE_BACK_BTN).on("click", function(e)
    {
      showLoginPart();
    });

    Shared.setupGameboardCodeInput("#link-boardcode-input");
  }

  function setUpLoginForm()
  {
    loginFormValidator = new FormValidator({
      selector: "#login-form",
      validateOnChange: true,
      rules: {
        username: {
          validator: (username) =>
          {
            return !utils.isNullOrEmpty(username) && username.trim() !== "";
          }
        },
        password: {
          validator: (password) =>
          {
            return !utils.isNullOrEmpty(password) && password.trim() !== "";
          }
        }
      }
    });

    log.info(loginFormValidator);
  }

  function clearAllFieldErrors()
  {
    $(".form-control").removeClass("is-invalid");
    $(".input-field-error").text("");
  }

  function login()
  {
    if(utils.isNull(loginFormValidator)) return;

    $("#login-error-msg").empty();

    clearAllFieldErrors();

    let formData = loginFormValidator.getFormData();

    let username = formData.username,
      password = formData.password;

    return LoginManager.login(username, password)
      .then((data) =>
      {
        let loginData = data.loginData,
          referer = data.referer;

        StorageController.saveToLocal(StorageController.keys.LOGGED_IN_USER, loginData);

        log.info("Referer: %s", referer);

        //if this is the first time the user logs in, redirect to profile setup
        if(data.userData.lastAuthenticated === null)
        {
          utils.redirect("/profile-setup-picture");
        }
        else
        {
          //if(!utils.isNullOrEmpty(referer) && referer.includes("/login"))
          if(!utils.isNullOrEmpty(referer))
          {
            utils.redirect("/sessions");
          }
          else
          {
            utils.redirect(referer);
          }
        }

      })
      .catch((appError) =>
      {
        log.error("Login failed");

        if (appError.code === Constants.APP_ERROR_USER_NOT_LINKED_TO_GAMEBOARD)
        {
          showLinkCodePart();
          return;
        }

        let message = LanguageManager.getValueForKey(appError.code);
        switch (appError.code)
        {
          case Constants.PASSWORD_INCORRECT:
            $("#login-password-input-error").text(message);
            $("#login-password-input").addClass("is-invalid");
            return;
          default:
            $("#login-username-input-error").text(message);
            $("#login-username-input").addClass("is-invalid");
        }

      });
  }

  function linkBoardcode()
  {
    clearAllFieldErrors();

    let input = $("#link-boardcode-input").removeClass("is-invalid");
    let code = input.val();
    let email = $("#login-username-input").val();

    if (utils.isNullOrEmpty(code))
    {
      input.addClass("is-invalid");
      return;
    }

    let $btn = $(LINK_BOARDCODE_BTN);
    $btn.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");

    UserServices.linkGameboard(email, code)
      .then((data) =>
      {
        input.val("");
        login();
      })
      .catch((appError) =>
      {
        input.addClass("is-invalid");
        let errorMessage = LanguageManager.getValueForKey(appError.code);
        $("#link-boardcode-input-error").html(errorMessage);

      }).finally(() =>
      {
        $btn.prop("disabled", false).removeClass("btn-loading");
      });
  }

  function showLoginPart()
  {
    $("#part-login").show();
    $("#part-register").show();
    $("#part-link-boardcode").hide();
  }

  function showLinkCodePart()
  {
    $("#part-login").hide();
    $("#part-register").hide();
    $("#part-link-boardcode").show();
  }

})(LoginPage);



// WEBPACK FOOTER //
// ./app/js/entries/login.js